import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import BasicText from '../../../../../Theme/Fonts/BasicText'

type Props = {
    type: 'HOME' | 'AWAY'
    value: string
    percentage: number
    isWinner?: boolean
}

const Value: FC<Props> = ({ type, value, percentage, isWinner }) => {
    return (
        <Grid
            marginRight={type === 'HOME' ? [2, 2, 3] : undefined}
            marginLeft={type === 'AWAY' ? [2, 2, 3] : undefined}
        >
            <BasicText
                textAlign={type === 'HOME' ? 'left' : 'right'}
                fontSize={['FS14', 'FS14', 'FS16']}
                lineHeight={['LH16', 'LH16', 'LH18']}
                color={isWinner ? 'onyx' : 'keshi-3'}
                bold={isWinner}
            >
                {value}
            </BasicText>
            <Grid noExpand height={4} horizontal center marginTop={2} reverse={type === 'AWAY'}>
                <Grid height={2} backgroundColor="moon-4" />
                {percentage ? (
                    <Grid
                        noExpand
                        width={`${percentage}%`}
                        height={4}
                        backgroundColor={isWinner ? 'onyx' : 'keshi-3'}
                    />
                ) : null}
            </Grid>
        </Grid>
    )
}

export default Value
